<template>
  <div class="app-layout">
    <TopBar
      v-if="showTopBar"
      :backToRoute="backToRoute"
      :backFrameRoute="backFrameRoute"
      :onlyLogoHeader="onlyLogoHeader"
    />

    <v-container
      class="main-container"
      :class="[bg, padding, extraClasses]"
    >
      <slot />
    </v-container>

    <BottomBar v-if="!onlyLogoHeader || showMenu" />
  </div>
</template>

<script>
import TopBar from "@/components/TopBar";
import BottomBar from "@/components/BottomBar";

export default {
  name: "MainLayout",
  props: {
    bg: String,
    backToRoute: [Boolean],
    removePadding: Boolean,
    extraClasses: String,
    onlyLogoHeader: Boolean,
    backFrameRoute: String,
    showMenu: {
      type: Boolean,
      default: false
    },
    showTopBar: {
      type: Boolean,
      default: true
    },
  },
  components: {
    TopBar,
    BottomBar,
  },
  computed: {
    padding() {
      return this.removePadding ? "pa-0" : "px-8";
    },
  },
};
</script>

<style scoped>
.app-layout {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  max-height: 100dvh;
  width: 100%;
  max-width: 390px;
  margin: 0 auto;
  overflow: hidden;
}

.main-container {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
